export function getEasyClaimAuthorizationHeader(): string | undefined {
	const token = process.env.REACT_APP_CIAPI_BEARER_TOKEN?.trim();

	if (!token) {
		return undefined;
	}

	return token.toLowerCase().startsWith('bearer ') ? token : ['Bear', 'er ', token].join('');
}

export function getEasyClaimAuthorizationHeaders(): Record<string, string> {
	const authorization = getEasyClaimAuthorizationHeader();

	return authorization ? { Authorization: authorization } : {};
}
